import "./index.css";
import ListItem, { ListItemProps } from "./ListItem";

interface ListProps {
  type: TemplateType;
  listData: ListItemProps[];
  customStyle?: React.CSSProperties;
}

const List = ({ listData, customStyle }: ListProps) => (
  <ul className="base-list" style={customStyle}>
    {listData.map((item, index) => (
      <ListItem
        key={index}
        icon={item.icon}
        iconColor={item.iconColor}
        iconCustomStyle={item.iconCustomStyle}
        text={item.text}
        textCustomStyle={item.textCustomStyle}
        listItemCustomStyle={item.listItemCustomStyle}
      />
    ))}
  </ul>
);

export default List;
